import AppleSigninButton from '@components/applesignin/AppleSigninButton';
import classNames from 'classnames';
import React from 'react';
import SocialButton from '@components/login/SocialButton';
const LoginOrRegisterSocial = (props) => {
    return (React.createElement("div", { className: "login-register-social-wrapper" },
        props.text && React.createElement("p", { className: "mb-20" }, props.text),
        React.createElement("div", { className: classNames('login-register-social', { 'links-view': !props.secondary, 'is-inline': props.inline }) },
            React.createElement(SocialButton, { social: "google", from: props.from, register: props.register, secondary: props.secondary, reloadUrl: props.reloadUrl, analyticsKey: props.analyticsKey }),
            React.createElement(SocialButton, { social: "facebook", from: props.from, register: props.register, secondary: props.secondary, reloadUrl: props.reloadUrl, analyticsKey: props.analyticsKey }),
            React.createElement(AppleSigninButton, { from: props.from, register: props.register, secondary: props.secondary, analyticsKey: props.analyticsKey }))));
};
export default LoginOrRegisterSocial;
